import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { AccApplicationDialogDataService } from '../../acc-application-dialog-data.service';
import { AlignedAccelerator } from '../aligned-accelerators.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, accApplDialogDataService: AccApplicationDialogDataService): GridSetup<AlignedAccelerator> {

	return {
		rowName: { singular: 'Accelerator', plural: 'Accelerators' },
		getRowKey: row => '' + row.accId,
		stateKey: 'application-dialog-aligned-accelerators-grid',
		actions: getActions(accApplDialogDataService),
		buttons: getButtons(accApplDialogDataService),
		columns: getColumns(util),
	}
}
